export default "__VITE_ASSET__6cdd3eae__"